module.exports = __webpack_public_path__ + "startpage-746fed5a/step4-2bea8f33787c0a7ee35dd04f2cd5031a.svg";